import { createAslenClient } from '@aslen/core/db';
import type { SupportedStorage } from '@supabase/supabase-js';

const REMEMBER_KEY = 'aslen.remember';

/** "Bu cihazda oturumu açık tut": localStorage when remembered, sessionStorage otherwise. */
export function setRememberSession(remember: boolean) {
  try {
    localStorage.setItem(REMEMBER_KEY, remember ? '1' : '0');
  } catch {
    /* private mode */
  }
}

function target(): Storage | null {
  try {
    return localStorage.getItem(REMEMBER_KEY) === '0' ? sessionStorage : localStorage;
  } catch {
    return null;
  }
}

const memory = new Map<string, string>();
const storage: SupportedStorage = {
  getItem: (k) => {
    try {
      return target()?.getItem(k) ?? localStorage.getItem(k) ?? sessionStorage.getItem(k) ?? memory.get(k) ?? null;
    } catch {
      return memory.get(k) ?? null;
    }
  },
  setItem: (k, v) => {
    try {
      const t = target();
      if (t) {
        t.setItem(k, v);
        (t === localStorage ? sessionStorage : localStorage).removeItem(k);
      } else memory.set(k, v);
    } catch {
      memory.set(k, v);
    }
  },
  removeItem: (k) => {
    memory.delete(k);
    try {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  },
};

export const env = {
  url: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  appUrl: (import.meta.env.VITE_APP_URL as string | undefined) ?? window.location.origin,
  /** Address other people open (invitation links). Differs from appUrl when this app runs on localhost against the hosted project. */
  // `||`, not `??`: an unset `VITE_PUBLIC_APP_URL=` line reaches the build as an empty string
  publicUrl:
    (import.meta.env.VITE_PUBLIC_APP_URL as string | undefined) || (import.meta.env.VITE_APP_URL as string | undefined) || window.location.origin,
};

export const isConfigured = Boolean(env.url && env.anonKey);

export const supabase = createAslenClient(env.url ?? 'http://127.0.0.1:54321', env.anonKey ?? 'missing-anon-key', {
  storage,
  detectSessionInUrl: true,
});

/** Simple KV for AslenProvider (company selection, reporting currency). */
export const kvStore = {
  getItem: (k: string) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  setItem: (k: string, v: string) => {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* ignore */
    }
  },
};
